import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../firebase/firebase.js";

const auth = getAuth(app);
const functions = getFunctions(app);
const generateTtsCallable = httpsCallable(functions, "generateTTSCallable");

export const fetchTtsUrl = async (text, voice = "alloy") => {
  const trimmed = (text || "").trim();
  if (!trimmed) {
    throw new Error("Text must be provided for TTS.");
  }

  await ensureUser();

  const { data } = await generateTtsCallable({ text: trimmed, voice });
  if (data?.url) {
    return data.url;
  }
  const error = new Error("generateTTS callable returned an unexpected payload.");
  error.response = data;
  throw error;
};

const ensureUser = async () => {
  if (auth.currentUser) {
    return auth.currentUser;
  }

  const user = await new Promise((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, (nextUser) => {
      unsubscribe();
      resolve(nextUser || null);
    });
  });

  if (!user) {
    throw new Error("You must be signed in to use text-to-speech.");
  }

  return user;
};
